import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { CourseState } from 'store/modules/course_store/types';
import { CircularProgressbar } from 'react-circular-progressbar';

import 'react-circular-progressbar/dist/styles.css';
import { getDataCourse } from 'store/modules/course_store/actions';
import { ProgressionCourseState } from 'store/modules/progression_course_store/types';
import { count_topics, getLastClass } from 'store/modules/progression_course_store/actions';
import ListTopics from 'components/molecules/list_topics';
import { PanelState } from 'store/modules/panel_store/types';
import { Container } from './styles';

interface ListModulesProps {
  scrollToVideo: () => void;
  searchBarOpened: boolean;
  setSearchBarOpened: React.Dispatch<React.SetStateAction<boolean>>;
  courseSubscriber: boolean;
}

const ListModules = (props: ListModulesProps) => {
  const { searchBarOpened, setSearchBarOpened, courseSubscriber, scrollToVideo } = props;
  const dispatch = useDispatch();

  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  const { course } = useSelector<ApplicationState, CourseState>((state) => state.session.course);
  const { progression_course } = useSelector<ApplicationState, ProgressionCourseState>(
    (state) => state.session.progression_course,
  );
  const progression =
    Number(progression_course?.progression) / Number(progression_course?.total_aula);

  useEffect(() => {
    dispatch(getDataCourse(2));
    dispatch(getLastClass(2));
    dispatch(count_topics());
  }, []);

  return (
    <Container>
      <div className="row">
        <div
          className={`col-11 mx-auto col-lg-3 col-md-12 pl-0 pr-1 filter-bar shadow ${
            panel?.registration_type_validation === 1 ? 'hasTopBanner' : ''
          } ${searchBarOpened ? '' : 'hide-bar'}`}
        >
          <button
            type="button"
            onClick={() => setSearchBarOpened(!searchBarOpened)}
            className="btn btn-sm btn-link position-absolute btn-hide-search d-xxl-none"
          >
            <i className="material-icons">keyboard_arrow_right</i>
          </button>
          <div className="filter-form mt-3">
            <div className="row d-print-none border-bottom pb-3 pt-2 px-3 align-items-center">
              <div className="col-3 pr-0">
                <CircularProgressbar
                  value={progression * 100}
                  text={`${Math.floor(progression * 100)}%`}
                />
              </div>
              <div className="col-9">
                <p className="title mb-0">{course?.name}</p>
                <span>
                  {progression_course?.progression} de {progression_course?.total_aula} aulas
                  completas
                </span>
              </div>
            </div>
            {course?.topics?.map((topic, index) => (
              <ListTopics
                key={topic.id}
                topic={topic}
                index={index}
                last_lesson={progression_course?.last_lasson?.ordem}
                courseSubscriber={courseSubscriber}
                scrollToVideo={scrollToVideo}
              />
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ListModules;
